// customerHotelActions.js
import {
    fetchCustomerHotels as apiFetchCustomerHotels,
    addCustomerHotel as apiAddCustomerHotel,
    updateCustomerHotel as apiUpdateCustomerHotel,
    deleteCustomerHotel as apiDeleteCustomerHotel,
  } from "../../api/customerHotel"; // Adjust path accordingly
  
  // Action Types
  export const FETCH_CUSTOMER_HOTEL_REQUEST = "FETCH_CUSTOMER_HOTEL_REQUEST";
  export const FETCH_CUSTOMER_HOTEL_SUCCESS = "FETCH_CUSTOMER_HOTEL_SUCCESS";
  export const FETCH_CUSTOMER_HOTEL_FAILURE = "FETCH_CUSTOMER_HOTEL_FAILURE";
  export const ADD_CUSTOMER_HOTEL_REQUEST = "ADD_CUSTOMER_HOTEL_REQUEST";
  export const ADD_CUSTOMER_HOTEL_SUCCESS = "ADD_CUSTOMER_HOTEL_SUCCESS";
  export const ADD_CUSTOMER_HOTEL_FAILURE = "ADD_CUSTOMER_HOTEL_FAILURE";
  export const UPDATE_CUSTOMER_HOTEL_REQUEST = "UPDATE_CUSTOMER_HOTEL_REQUEST";
  export const UPDATE_CUSTOMER_HOTEL_SUCCESS = "UPDATE_CUSTOMER_HOTEL_SUCCESS";
  export const UPDATE_CUSTOMER_HOTEL_FAILURE = "UPDATE_CUSTOMER_HOTEL_FAILURE";
  export const DELETE_CUSTOMER_HOTEL_REQUEST = "DELETE_CUSTOMER_HOTEL_REQUEST";
  export const DELETE_CUSTOMER_HOTEL_SUCCESS = "DELETE_CUSTOMER_HOTEL_SUCCESS";
  export const DELETE_CUSTOMER_HOTEL_FAILURE = "DELETE_CUSTOMER_HOTEL_FAILURE";
  
  // Action Creators
  export const fetchCustomerHotelRequest = () => ({ type: FETCH_CUSTOMER_HOTEL_REQUEST });
  export const fetchCustomerHotelSuccess = (hotels) => ({
    type: FETCH_CUSTOMER_HOTEL_SUCCESS,
    payload: hotels,
  });
  export const fetchCustomerHotelFailure = (error) => ({
    type: FETCH_CUSTOMER_HOTEL_FAILURE,
    payload: error,
  });
  export const addCustomerHotelRequest = () => ({ type: ADD_CUSTOMER_HOTEL_REQUEST });
  export const addCustomerHotelSuccess = (hotel) => ({
    type: ADD_CUSTOMER_HOTEL_SUCCESS,
    payload: hotel,
  });
  export const addCustomerHotelFailure = (error) => ({
    type: ADD_CUSTOMER_HOTEL_FAILURE,
    payload: error,
  });
  export const updateCustomerHotelRequest = () => ({
    type: UPDATE_CUSTOMER_HOTEL_REQUEST,
  });
  export const updateCustomerHotelSuccess = (hotel) => ({
    type: UPDATE_CUSTOMER_HOTEL_SUCCESS,
    payload: hotel,
  });
  export const updateCustomerHotelFailure = (error) => ({
    type: UPDATE_CUSTOMER_HOTEL_FAILURE,
    payload: error,
  });
  export const deleteCustomerHotelRequest = () => ({
    type: DELETE_CUSTOMER_HOTEL_REQUEST,
  });
  export const deleteCustomerHotelSuccess = (id) => ({
    type: DELETE_CUSTOMER_HOTEL_SUCCESS,
    payload: id,
  });
  export const deleteCustomerHotelFailure = (error) => ({
    type: DELETE_CUSTOMER_HOTEL_FAILURE,
    payload: error,
  });
  
  // Thunks
  export const fetchCustomerHotel = () => async (dispatch) => {
    dispatch(fetchCustomerHotelRequest());
    try {
      const hotels = await apiFetchCustomerHotels();
      dispatch(fetchCustomerHotelSuccess(hotels.result));
    } catch (error) {
      dispatch(fetchCustomerHotelFailure(error.message));
    }
  };
  
  export const addCustomerHotel = (hotel) => async (dispatch) => {
    dispatch(addCustomerHotelRequest());
    try {
      const newHotel = await apiAddCustomerHotel(hotel);
      dispatch(addCustomerHotelSuccess(newHotel.data));
      return newHotel;
    } catch (error) {
      dispatch(addCustomerHotelFailure(error.response?.data?.message || error.message));
      throw error;
    }
  };
  
  export const updateCustomerHotel = (hotel) => async (dispatch) => {
    dispatch(updateCustomerHotelRequest());
    try {
      const updatedHotel = await apiUpdateCustomerHotel({ ...hotel });
      dispatch(updateCustomerHotelSuccess(updatedHotel.data));
      return updatedHotel;
    } catch (error) {
      dispatch(updateCustomerHotelFailure(error.response?.data?.message || error.message));
      throw error;
    }
  };
  
  export const deleteCustomerHotel = (id) => async (dispatch) => {
    dispatch(deleteCustomerHotelRequest());
    try {
      await apiDeleteCustomerHotel(id);
      dispatch(deleteCustomerHotelSuccess(id));
    } catch (error) {
      dispatch(deleteCustomerHotelFailure(error.message));
      throw error;
    }
  };
  
